import React from 'react'
import { DatePicker, TextFieldDisplayType } from '@deal/components'
import { DatePathFlowQuestionDefinition } from '#src/components/Path/Question'
import styles from './styles.css'

interface CustomProps {
  display?: TextFieldDisplayType
}

interface DatePathFlowQuestionState {
  selectedDay?: Date
}

class DatePathFlowQuestion extends React.PureComponent<
  DatePathFlowQuestionDefinition<CustomProps>,
  DatePathFlowQuestionState
> {
  constructor(props: DatePathFlowQuestionDefinition<CustomProps>) {
    super(props)

    const { question } = props

    this.state = {
      selectedDay: question.dateUserInput.value ? new Date(question.dateUserInput.value) : undefined
    }

    this.handleDayChange = this.handleDayChange.bind(this)
  }

  public componentDidMount() {
    const { question } = this.props

    if (question.dateUserInput.value) {
      this.props.onFieldValueChanged({
        value: question.dateUserInput.value
      })
    }

    if (!question.required) {
      this.props.onFieldValidityChanged(true)
    }
  }

  public handleDayChange(date: Date) {
    this.props.onFieldValidityChanged(true)
    this.props.onFieldValueChanged({ value: date.toISOString() })

    this.setState({ selectedDay: date })
  }

  public render() {
    const { selectedDay } = this.state

    return (
      <div className={styles.input} data-testid="date-picker">
        <DatePicker
          selectedDay={selectedDay}
          label="Service Date"
          dayPickerProps={{ disabledDays: { before: new Date() } }}
          onDayChange={this.handleDayChange}
        />
      </div>
    )
  }
}

export default DatePathFlowQuestion
